<block-ui *ngIf="this.member != null">
  <div *ngIf="this.loaded==true" class="container mt-4 row">
    <div *ngIf="this.lessonPlans.length == 0">
      You have no lesson plans
    </div>
    <div *ngIf="this.lessonPlans.length > 0" class="row">
      <div class="row">
        <div class="col col-sm-3"><b>Show Active</b></div>
        <div class="col col-sm-3">
          <input type="checkbox" id="filterActive" name="filterActive" checked="this.isActive" (change)="this.changeIsActive($event)" />
        </div>
      </div>
      <div *ngIf="this.filteredPlans.length == 0">
        No lesson plans match your criteria
      </div>
      <div *ngIf="this.filteredPlans.length > 0">
        <div class="row">
          <div class="table-title" colspan="6">Lesson Plans</div>
        </div>
        <div class="row">
          <div class="col column-label">Actions</div>
          <div class="col column-label">Title</div>
          <div class="col column-label">Due Date</div>
          <div class="col column-label">Steps</div>
          <div class="col column-label">Participants</div>
          <div class="col column-label">Invitees</div>
        </div>
        <div class="row" *ngFor="let plan of this.filteredPlans; let i = index;" [ngClass]="{'evenRow':i % 2 == 0, 'oddRow': i % 2 != 0}">
          <div class="col" style="text-align: right;">
            <input *ngIf="canUpdate(plan)" type="button" value="Edit" (click)="this.editPlan(plan.id)"/>
            <input type="button" value="View" (click)="this.viewPlan(plan.id)"/>
          </div>
          <div class="col">{{ plan.title }}</div>
          <div class="col">{{ this.datePipe.transform(plan.dueDate, 'MM-dd-yyyy') }}</div>
          <div class="col">{{ plan.planItems.length }}</div>
          <div class="col">{{ this.displayParticipants(plan.planMembers) }}</div>
          <div class="col">{{ this.displayInvitees(plan.planMembers) }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <input type="button" id="createPlan" name="createPlan" value="Create Plan" (click)="this.editPlan(0)" />
    </div>
    <div *ngIf="this.invitations.length > 0" >
        <div class="row">
          <div class="col" class="table-title">Pending Invitations</div>
        </div>
        <div class="row">
          <div class="col column-label">Actions</div>
          <div class="col column-label">Title</div>
          <div class="col column-label">Due Date</div>
          <div class="col column-label">Steps</div>
          <div class="col column-label">Participants</div>
          <div class="col column-label">Invitees</div>
        </div>
        <div class="row" *ngFor="let plan of this.invitations; let i = index;" [ngClass]="{'evenRow':i % 2 == 0, 'oddRow': i % 2 != 0}">
          <div class="col">
            <input type="button" value="Accept" (click)="respond(plan, true)"/>
            <input type="button" value="Reject" (click)="respond(plan, false)"/>
          </div>
          <div class="col">{{ plan.title }}</div>
          <div class="col">{{ this.datePipe.transform(plan.dueDate, 'MM-dd-yyyy') }}</div>
          <div class="col">{{ plan.planItems.length }}</div>
          <div class="col">{{ this.displayParticipants(plan.planMembers) }}</div>
          <div class="col">{{ this.displayInvitees(plan.planMembers) }}</div>
        </div>
    </div>
  </div>
</block-ui>
